<template>
	<div
		:style="$grid('1')"
		class="ignore-deal-lock"
	>
		<PanelDealJacket
			:fimenu="props.deal"
			:rootName="props.rootName"
		/>
	</div>
</template>
<script setup lang="ts">
	import FIMenu from '@core/classes/FIMenu';
	import PanelDealJacket from './PanelDealJacket.vue';
	import { CreateEContract } from '@core/helpers/finance-channels-helper';

	interface PageDealJacketProps {
		deal: FIMenu;
		rootName: string;
	}

	const props = defineProps<PageDealJacketProps>();
</script>
<style scoped></style>
